import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PipesModule } from '@fcom/common/pipes/pipes.module';
import { ComponentsModule } from '@fcom/common/components/components.module';
import { UiTranslateModule } from '@fcom/ui-translate';
import { UiComponentsModule } from '@fcom/ui-components';
import { DirectiveModule } from '@fcom/common';

import { TravelRestrictionsComponent } from './travel-restrictions.component';
import { TravelRestrictionsSmartvelComponent } from './travel-restrictions-smartvel.component';

@NgModule({
  imports: [CommonModule, PipesModule, UiTranslateModule, UiComponentsModule, ComponentsModule, DirectiveModule],
  declarations: [TravelRestrictionsComponent, TravelRestrictionsSmartvelComponent],
  exports: [TravelRestrictionsComponent, TravelRestrictionsSmartvelComponent],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TravelRestrictionsModule {}
